export default function IconButton(theme) {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: '500px'
                },
                sizeLarge: {
                    width: '48px',
                    height: '48px',
                    borderRadius: '16px',
                },
                sizeMedium: {
                    width: '40px',
                    height: '40px',
                    borderRadius: '16px'
                },
                sizeSmall: {
                    width: '36px',
                    height: '36px',
                    borderRadius: '12px',
                },
                sizeXs: {
                    width: '28px',
                    height: '28px',
                    borderRadius: '10px',
                }
            }
        }
    };
}
